<section class="service-details">
  <div class="row fc-service-breadcrumb">
    <div class="col-8">
      <button
        class="teams-btn"
        [attr.Pixel-tracking]="true"
        [attr.Pixel-title]="'Help Click'"
        (click)="navigateToTeams()"
      >
        Need Help ?<span
          ><img
            src="../../../../assets/imagesV4/footer-Teams.svg"
            mattooltip="Teams"
            mattooltipposition="above"
            class="mat-mdc-tooltip-trigger"
        /></span>
      </button>
    </div>
    <div class="col-4">
      <div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Forecast Service Details</li>
            <li>
              <button
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Documentation'"
                class="uitk-icon uitk-icon-info_hollow md-icon border-0"
                title="Info"
                (click)="info()"
              ></button>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  @if (showLoader) {
  <div class="stk-table-loader fc-service-loader">
    <app-loader> </app-loader>
  </div>
  } @if (!showLoader && dataSource) {
  <div>
    <div class="master-card-section margin-botton-5">
      <app-forecast-master-card
        [masterData]="masterData"
        [dataSource]="dataSource"
        [currentYear]="currentYear"
      ></app-forecast-master-card>
    </div>
    <div class="ac-fc-section margin-botton-5">
      <mat-accordion>
        <mat-expansion-panel #panel expanded (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header class="panel-header p-0" hideToggle="true">
            <mat-panel-title class="w-100">
              <div class="row accordion-heading-row me-0">
                <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 flex-container">
                  <div class="flex-item title-item" (click)="$event.stopPropagation()">
                    <label
                      class="card-heading  Infrastructure Services tile-heading table-Header-Nav-font no-wrap-label"
                    >
                      <mat-icon class="expansion-icon" (click)="togglePanel($event, panel)">{{
                        panel.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                      }}</mat-icon>
                      <span>{{ showCharge ? 'Actuals & Forecast By Charge' : 'Actuals & Forecast By Volume' }}</span>
                    </label>
                  </div>
                  <div class="flex-item decom-item" (click)="$event.stopPropagation()">
                    @if (masterData?.decom_date) {
                    <label
                      class="card-heading  Infrastructure Services tile-heading table-Header-Nav-font h-100 no-wrap-label"
                      >Decom Validation Date:<span class="black-text ms-1">{{
                        masterData?.decom_date | date: 'longDate'
                      }}</span></label
                    >
                    }
                  </div>
                  <div class="flex-item" (click)="$event.stopPropagation()">
                    <label [ngClass]="{ 'hide-msg': !checkDecomFCData() }" class="decom-msg h-100"
                      >Forecast added for post planned Decommission Months</label
                    >
                  </div>
                </div>
                <div
                  class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4  table-actions"
                  (click)="$event.stopPropagation()"
                >
                  <div class="switch-toggle-div">
                    <label class="switch-toggle-label costview-info-font me-2 mb-0">By Volume</label>
                    <mat-slide-toggle
                      [color]="'#013b71'"
                      style="float:right;"
                      (change)="apptoggle($event)"
                      class="app-toggle"
                    >
                    </mat-slide-toggle>
                    <label class="switch-toggle-label costview-info-font ms-2 mb-0">By Charge</label>
                    <div class="export-link ps-3">
                      <span
                        class="me-3"
                        (click)="openReportLink()"
                        title="Click to view the infrastructure consumption details"
                      >
                        <img class="add-report-link-img" src="../../../../assets/imagesV4/Link.png" />
                      </span>
                      <span
                        [attr.Pixel-tracking]="true"
                        [attr.Pixel-title]="'Download'"
                        class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                        title="Click to download"
                        (click)="excelDownload()"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
              <div (click)="$event.stopPropagation()">
                @if (panelOpenState) {
                <div class="row m-0 table-row">
                  <div class="col-12 table-container p-0 ac-fc-table" [hidden]="showCharge">
                    @if (volumeACdataSource.length) {
                    <mat-table [dataSource]="volumeACdataSource">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">Actuals By Year</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          <div class="column-container">
                            <span>{{ element[column] }}</span>
                            <p class="total_txt">Total: {{ element['total'] | number: '1.0-0' }}</p>
                          </div>
                        </mat-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          <span> {{ element[column] | number: '1.0-0' }}</span>
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                    }
                  </div>
                  <div class="col-12 table-container p-0 ac-fc-table" [hidden]="!showCharge">
                    @if (chargeACdataSource.length) {
                    <mat-table [dataSource]="chargeACdataSource">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">Actuals By Year</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          <div class="column-container">
                            <span>{{ element[column] }}</span>
                            <p class="total_txt">Total: ${{ element['total'] | number: '1.0-0' }}</p>
                          </div>
                        </mat-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          @if ((element[column]||element[column]==0)) {
                          <span> ${{ element[column] | number: '1.0-0' }}</span>
                          }
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                    }
                  </div>
                </div>
                }
                <div class="row forecast-action-row m-0 ms-3">
                  <div class="col-9 ps-5">
                    <div class="d-flex">
                      <div class="flex-item">
                        @if (masterData.Attested_By != null) {
                        <mat-icon aria-hidden="false" class="check-icon greenbg" fontIcon="check_circle"></mat-icon>
                        } @if (masterData.Attested_By_Offc != null) {
                        <mat-icon aria-hidden="false" class="check-icon purplebg" fontIcon="check_circle"></mat-icon>
                        }
                        <label>Forecast</label>
                      </div>
                      @if (forecastCycleType?.msg) {
                      <div class="flex-item forecast-notification-txt">
                        <label class="forecast-msg h-100"
                          >{{ forecastCycleType?.msg }}@if (forecastCycleType?.msg2) {
                          <span class="edit-txt">{{ forecastCycleType?.msg2 }}</span>
                          }@if (forecastCycleType?.msg3) {
                          <span>{{ forecastCycleType?.msg3 }}</span>
                          }@if (forecastCycleType?.submsg) {
                          <span [ngClass]="forecastCycleType?.type"> {{ forecastCycleType?.submsg }}</span>
                          }</label
                        >
                      </div>
                      }
                    </div>
                  </div>
                  <div class="col-3 forecast-action-item">
                    @if (!showCharge && currentMode=='normal') {
                    <button
                      [disabled]="!checkEditAccess()"
                      (click)="editFC('normal')"
                      class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1 me-1"
                    >
                      Edit
                    </button>
                    } @if (!showCharge && currentMode=='edit') {
                    <button
                      (click)="editFC('edit')"
                      class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1"
                    >
                      Cancel
                    </button>
                    } @if (!showCharge ) {
                    <button
                      [disabled]="currentMode == 'normal' || !checkEditAccess()"
                      (click)="showAttestationPopup()"
                      class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1"
                    >
                      {{ forecastCycleType?.type == 'Off-cycle' ? 'Apply' : 'Apply & attest' }}
                    </button>
                    }
                  </div>
                </div>
                <div class="row m-0 table-row pb-3">
                  @if (volumeFCdataSource) {
                  <div class="col-12 table-container p-0 ac-fc-table forecast-table" [hidden]="showCharge">
                    <mat-table [dataSource]="volumeFCdataSource['firstTable']">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">{{
                          forecastCycleType?.type == 'Off-cycle' ? 'Update Cycle' : 'Forecast Cycle'
                        }}</mat-header-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          @if (enableEdit(element,column) && currentMode=='edit' && element['label']!='Variance') {
                          <input
                            type="text"
                            appIntegerOnly
                            [allowNegative]="allowNegative"
                            appDisableDragDrop
                            [(ngModel)]="element[column]"
                            (keyup)="onChange(element[column], column, element, $event)"
                            class="blue-text"
                            (keydown)="$event.stopPropagation()"
                            [ngClass]="{ 'red-border': checkDecomFCMonth(element, column) }"
                          />
                          } @if ( column!='Year' && element['label']!='Variance' &&
                          (!enableEdit(element,column)||enableEdit(element,column)&& currentMode=='normal')) {
                          <span [ngClass]="gettextcolor(element, column)">{{
                            element[column] ? element[column] : 0
                          }}</span>
                          } @if (column!='Year' && element['label']=='Variance') {
                          <span class="Variance">
                            {{ element[column] | number: '1.0-0' }}<sub>{{ getPercentage(column, element) }}</sub></span
                          >
                          }
                        </mat-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          @if (element['label']!='Variance') {
                          <div class="column-container">
                            <span
                              matTooltip="{{ element['tooltip'] }}"
                              matTooltipClass="my-custom-tooltip"
                              matTooltipPosition="above"
                              [innerHtml]="element['label']"
                              class="forecast_cycle_label"
                            ></span>
                            <p class="total_txt">
                              @if (element['cycle'] !='current' && currentMode=='edit') {
                              <img
                                src="/assets/imagesV4/copyimg.png"
                                (click)="copyToCurrent(element); $event.stopPropagation()"
                                [matTooltip]="getCopyIconToolTipMsg(element)"
                                matTooltipClass="my-custom-tooltip"
                                matTooltipPosition="below"
                                class="copy-img"
                              />
                              } Total: {{ element['total'] | number: '1.0-0' }}
                            </p>
                          </div>
                          } @if (element['label']=='Variance') {
                          <span class="variance-cell">{{ element['label'] }}</span>
                          }
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                    <mat-table [dataSource]="volumeFCdataSource['secondTable']">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast Cycle</mat-header-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          @if (enableEdit(element,column) && currentMode=='edit' && element['label']!='Variance') {
                          <input
                            type="text"
                            appIntegerOnly
                            [allowNegative]="allowNegative"
                            appDisableDragDrop
                            [(ngModel)]="element[column]"
                            (keyup)="onChange(element[column], column, element, $event)"
                            class="blue-text"
                            (keydown)="$event.stopPropagation()"
                            [ngClass]="{ 'red-border': checkDecomFCMonth(element, column) }"
                          />
                          } @if ( column!='Year' && element['label']!='Variance' &&
                          (!enableEdit(element,column)||enableEdit(element,column)&& currentMode=='normal')) {
                          <span [ngClass]="gettextcolor(element, column)">{{
                            element[column] ? element[column] : 0
                          }}</span>
                          } @if (column!='Year' && element['label']=='Variance') {
                          <span class="Variance">
                            {{ element[column] | number: '1.0-0' }}<sub>{{ getPercentage(column, element) }}</sub></span
                          >
                          }
                        </mat-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          @if (element['label']!='Variance') {
                          <div class="column-container">
                            <span
                              matTooltip="{{ element['tooltip'] }}"
                              matTooltipClass="my-custom-tooltip"
                              matTooltipPosition="above"
                              [innerHtml]="element['label']"
                              class="forecast_cycle_label"
                            ></span>
                            <p class="total_txt">
                              @if (element['cycle'] !='current' && currentMode=='edit') {
                              <img
                                src="/assets/imagesV4/copyimg.png"
                                (click)="copyToCurrent(element); $event.stopPropagation()"
                                [matTooltip]="getCopyIconToolTipMsg(element)"
                                matTooltipClass="my-custom-tooltip"
                                matTooltipPosition="below"
                                class="copy-img"
                              />
                              } Total: {{ element['total'] | number: '1.0-0' }}
                            </p>
                          </div>
                          } @if (element['label']=='Variance') {
                          <span class="variance-cell">{{ element['label'] }}</span>
                          }
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns" [class.hidden]="true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                  </div>
                  }
                  <div class="col-12 table-container p-0 ac-fc-table forecast-table" [hidden]="!showCharge">
                    <mat-table [dataSource]="chargeFCdataSource['firstTable']">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast Cycle</mat-header-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          @if (element['label']!='Variance') {
                          <span [ngClass]="gettextcolor(element, column)"
                            >${{ element[column] ? element[column] : 0 }}</span
                          >
                          } @if (column!='Year' && element['label']=='Variance') {
                          <span class="Variance">
                            ${{ element[column] | number: '1.0-0'
                            }}<sub>{{ getPercentage(column, element) }}</sub></span
                          >
                          }
                        </mat-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          @if (element['label']!='Variance') {
                          <div class="column-container">
                            <span
                              matTooltip="{{ element['tooltip'] }}"
                              matTooltipClass="my-custom-tooltip"
                              matTooltipPosition="above"
                              [innerHtml]="element['label']"
                              class="forecast_cycle_label"
                            ></span>
                            <p class="total_txt">Total: ${{ element['total'] | number: '1.0-0' }}</p>
                          </div>
                          } @if (element['label']=='Variance') {
                          <span class="variance-cell">{{ element['label'] }}</span>
                          }
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                    <mat-table [dataSource]="chargeFCdataSource['secondTable']">
                      @for (column of displayedColumns; track column) {
                      <ng-container [matColumnDef]="column">
                        @if (column!='Year') {
                        <mat-header-cell *matHeaderCellDef>{{ column }}</mat-header-cell>
                        } @if (column=='Year') {
                        <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast Cycle</mat-header-cell>
                        } @if (column!='Year') {
                        <mat-cell *matCellDef="let element">
                          @if (element['label']!='Variance') {
                          <span [ngClass]="gettextcolor(element, column)"
                            >${{ element[column] ? element[column] : 0 }}</span
                          >
                          } @if (column!='Year' && element['label']=='Variance') {
                          <span class="Variance">
                            ${{ element[column] | number: '1.0-0'
                            }}<sub>{{ getPercentage(column, element) }}</sub></span
                          >
                          }
                        </mat-cell>
                        } @if (column=='Year') {
                        <mat-cell *matCellDef="let element" class="actual-yr-val">
                          @if (element['label']!='Variance') {
                          <div class="column-container">
                            <span
                              matTooltip="{{ element['tooltip'] }}"
                              matTooltipClass="my-custom-tooltip"
                              [innerHtml]="element['label']"
                              class="forecast_cycle_label"
                            ></span>
                            <p class="total_txt">Total: ${{ element['total'] | number: '1.0-0' }}</p>
                          </div>
                          } @if (element['label']=='Variance') {
                          <span class="variance-cell">{{ element['label'] }}</span>
                          }
                        </mat-cell>
                        }
                      </ng-container>
                      }
                      <mat-header-row *matHeaderRowDef="displayedColumns" [class.hidden]="true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      </mat-accordion>
      @if (lastModified ) {
      <div class="col-12 d-flex lastModifiedSection white-bg pb-2">
        <div class="lastModified ">
          Last Modified by {{ dataSource.Updated_By }} on {{ dataSource.Updated_At | date: 'MMM d, y, h:mm:ss a' }}
        </div>
      </div>
      }
    </div>
    @if (commentsArray.length > 0) {
    <div class="col-12 mt-1 white-bg display-comments margin-botton-5 ">
      <label class="tabl-header-font">Comments</label>
      <ul class="comments-list ps-2 mb-0">
        @for (comment of commentsArray; track comment) { @if (comment.Comments !== null && comment.Comments !==
        undefined) {
        <li class="comment-item">
          <div class="comment-meta">
            <span class="comment-date">{{ comment.Updated_At | date: 'MMM d, y':'GMT' }}</span>
            <span class="comment-updated-by"
              >Updated by {{ comment.Updated_By }} at {{ comment.Updated_At | date: 'h:mm:ss a':'GMT' }} GMT</span
            >
          </div>
          <p class="comment-text mb-0">{{ comment.Comments ? comment.Comments : 'No Comment Added' }}</p>
        </li>
        } }
      </ul>
    </div>
    } @if (commentsArray.length === 0) {
    <div class="mt-2 height-1 margin-botton-5 "></div>
    }
    <div class=" row white-bg comments-section m-0 margin-botton-5 pb-0">
      <div class="col-12 pos-static">
        <label class="tabl-header-font">Forecast By {{ showCharge ? 'Charge' : 'Volume' }} Trends</label>
        <div class="graph-section">
          <div [hidden]="chartData.length == 0">
            <app-multi-line-chart
              [label]="label"
              [minrange]="minrange"
              [maxRange]="maxrange"
              [data]="chartData"
            ></app-multi-line-chart>
          </div>
          <div class="info-div">
            <div class="pullUp first">
              <div class="square square-size dev actuals"></div>
              <p class="legend legend-font">Actuals</p>
            </div>
            <div class="pullUp">
              <div class="square square-size om fc1"></div>
              <p class="legend legend-font">Forecast Cycle( {{ previousFC.Forecast_Cycle }} )</p>
            </div>
            <div class="pullUp">
              <div class="square square-size om fc2"></div>
              <p class="legend legend-font">Forecast Cycle( {{ currentFC.Forecast_Cycle }} )</p>
            </div>
            <div class="pullUp">
              <div class="square square-size om fc3"></div>
              <p class="legend legend-font">Projections( {{ currentFC.Forecast_Cycle }} )</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearall"></div>
  </div>
  }
</section>

<app-modal [maximizable]="true" [inViewport]="true" #attestationPopup class="modal-demo attestation-popup">
  <ng-container class="app-modal-body">
    <div class="col-12 ps-0 ">
      <p class="attestation-title">{{ attestation_popup_title }}</p>
      <label class="tabl-header-font">Comments</label>
      @if (valueExceedLmt.length>0 || this.decomcount > 0) {
      <sup class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></sup>
      }
      <textarea
        [(ngModel)]="newcomments"
        [disabled]="!checkEditAccess() || currentMode == 'normal'"
        class="w-100 form-control comments-input"
        cols="10"
        rows="5"
        [placeholder]="commentsPlaceholderText"
        maxlength="3000"
      ></textarea>

      @if (comments?.length!=3000) {
      <div class="help-block uitk-c-input__message--error" style="background-color:green;width: 100%;">
        <span> {{ 3000 - comments?.length }} Char Left </span>
      </div>
      } @if (comments?.length == 3000) {
      <div class="help-block uitk-c-input__message--error">
        0 Char Left
      </div>
      }
    </div>
    <div class="d-flex attestation-button m-1">
      <button
        (click)="hideAttestationPopup()"
        class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size me-2"
      >
        Cancel
      </button>
      <button
        (click)="submitForecast()"
        class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
        [disabled]="checkBtnDisability()"
      >
        Continue
      </button>
    </div>
  </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #varianceDetectedPopup class="modal-demo variance-detected-popup">
  <ng-container class="app-modal-header">
    Variance Detected
    <button
      class="uitk-icon uitk-icon-info_hollow md-icon variance-header-info-icon"
      title="Info"
      (click)="info()"
    ></button>
  </ng-container>
  <ng-container class="app-modal-body">
    @if (variancePopupLoading) {
    <div class="variance-popup-loader-overlay">
      <app-loader></app-loader>
    </div>
    }
    <div class="row variance-driver-row">
      <button class="variance-driver-badge">Driver : {{ varianceDriverType }}</button>
    </div>
    <div class="row m-0 variance-body-row">
      <div class="col-8 variance-detail-col">
        <div class="variance-detail-card">
          <div class="variance-service-row">
            <span class="variance-label">Service:</span>
            <span class="variance-value">{{ varianceServiceName }}</span>
          </div>
          <div class="variance-metric-row">
            <span class="variance-metric-value"
              >{{ formatVarianceMetric(varianceMetricChange) }} {{ varianceMetricUnit }}</span
            >
            <sup
              class="variance-metric-percent"
              [ngClass]="isVariancePercentPositive() ? 'variance-percent-up' : 'variance-percent-down'"
            >
              <mat-icon
                class="variance-percent-icon"
                [fontIcon]="isVariancePercentPositive() ? 'arrow_upward' : 'arrow_downward'"
              ></mat-icon
              >{{ formatVariancePercentValue() }}%
            </sup>
            <span class="variance-metric-vs">vs</span>
            <span class="variance-metric-baseline"
              >{{ forecastCycle }} ({{ formatVarianceMetric(varianceMetricBaseline) }})</span
            >
          </div>
          <div class="variance-divider"></div>
          <p class="variance-explain-heading">Explain this variance to attest</p>
          <label class="variance-field-label"
            >Business Driver
            <sup class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></sup>
          </label>
          <input
            type="text"
            class="form-control variance-input"
            [(ngModel)]="businessDriver"
            placeholder="Who directed this / What mandate.."
          />
          <label class="variance-field-label"
            >Workload/basis
            <sup class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></sup>
          </label>
          <input
            type="text"
            class="form-control variance-input"
            [(ngModel)]="workloadBasis"
            placeholder="Claims Analytics scoring engine - 160 Gb dedicted RAM"
          />
          <button
            type="button"
            (click)="generateComments()"
            [disabled]="!canGenerateComments() || variancePopupLoading"
            class="add-apply generate-comment-btn m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
          >
            Generate Comments
          </button>
          <textarea
            class="w-100 form-control variance-textarea"
            rows="4"
            [(ngModel)]="aiGeneratedComment"
            placeholder="Type here..."
          ></textarea>
        </div>
      </div>
      <div class="col-4 variance-quality-col">
        <div class="variance-quality-card">
          <p class="variance-quality-heading">Quality</p>
          <div class="variance-quality-bars">
            @for (bar of qualityBars; track bar; let i = $index) {
            <span class="quality-bar" [ngClass]="{ filled: i < qualityScore }"></span>
            }
            <span class="quality-count">{{ qualityScore }}/{{ qualityBars.length }}</span>
          </div>
          @if (commentsValidated) {
          <div class="quality-checklist">
            @for (item of qualityChecklist; track item) {
            <div class="quality-checklist-item">
              <div class="quality-checklist-title">
                @if (item.status === 'warning') {
                <mat-icon class="quality-icon quality-icon-warning" fontIcon="warning"></mat-icon>
                } @if (item.status === 'check') {
                <mat-icon class="quality-icon quality-icon-check" fontIcon="check"></mat-icon>
                }
                <span class="quality-checklist-label">{{ item.label }}</span>
              </div>
              <!-- <div class="quality-checklist-desc">{{item.description}}</div> -->
            </div>
            }
          </div>
          } @if (commentsValidated) {
          <div class="quality-tip-box">{{ qualityImprovementTip }}</div>
          }
        </div>
      </div>
    </div>
    <div class="d-flex variance-footer-actions m-1">
      <button
        (click)="checkVarianceComment()"
        [disabled]="!canValidateComments() || variancePopupLoading"
        class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
      >
        Validate Comments
      </button>
      <button
        (click)="saveAndAttestVariance()"
        [disabled]="!canSaveAndAttestVariance() || variancePopupLoading"
        class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
      >
        Save & Attest
      </button>
    </div>
  </ng-container>
</app-modal>
